import OtProjectClaimsIndex from '@/areas/projects/claims/ot-project-claims-index.vue';
import OtProjectContractsIndex from '@/areas/projects/contracts/ot-project-contracts-index.vue';
import OtProjectDocumentLayout from '@/areas/projects/documents/ot-project-document-layout.vue';
import OtProjectDocumentsIndex from '@/areas/projects/documents/ot-project-documents-index.vue';
import OtEditProjectDetails from '@/areas/projects/ot-edit-project-details.vue';
import OtProjectDetails from '@/areas/projects/ot-project-details.vue';
import OtProjectsIndex from '@/areas/projects/ot-projects-index.vue';
import OtProjectsLayout from '@/areas/projects/ot-projects-layout.vue';
import OtEditProjectUserDetails from '@/areas/projects/users/ot-edit-project-user.vue';
import OtProjectUserContractsIndex from '@/areas/projects/users/ot-project-user-contracts-index.vue';
import OtProjectUserDetails from '@/areas/projects/users/ot-project-user-details.vue';
import OtProjectUserLayout from '@/areas/projects/users/ot-project-user-layout.vue';
import OtProjectUsersIndex from '@/areas/projects/users/ot-project-users-index.vue';
// bog standard import. Didn't render, didn't mount, didn't do diddly
// import OtDocumentAssociations from '@/components/documents/document-associations/ot-document-associations-list.vue';
// didn't fix the non rendering issue
// import OtDocumentAssociations from '../../components/documents/document-associations/ot-document-associations-list.vue';
// the name of the import should not matter. It did not matter. It's a default export so we could say Import YoMomma and it'd be valid.
// import OtDocumentAssociationsList from '@/components/documents/document-associations/ot-document-associations-list.vue';
// a wrapper component. This did actually fix the issue, but it feels wrong
// import OtDocumentAssociationsListWrapper from '@/components/documents/document-associations/ot-document-associations-list-wrapper.vue';

import OtDocumentDetails from '@/components/documents/document-details/ot-document-details.vue';
import { RouteConfig } from 'vue-router';
// import OtComingSoonPage from '@/components/global/ot-coming-soon.vue';

import { BreadcrumbsId } from '@/components/global/common-models';

export const ROUTE_PROJECT = 'Projects';
export const ROUTE_PROJECT_DETAILS = 'ProjectDetails';
export const ROUTE_PROJECT_USERS = 'ProjectUsers';

export const ROUTE_PROJECT_USER_DETAILS = 'ProjectUserDetails';
export const ROUTE_PROJECT_USER_CONTRACTS = 'ProjectUserContracts';
export const ROUTE_PROJECT_USER_EDIT = 'ProjectUserEdit';

export const ROUTE_PROJECT_CONTRACTS = 'ProjectContracts';
export const ROUTE_PROJECT_WORKFLOWS = 'ProjectWorkflows';
export const ROUTE_PROJECT_DOCUMENTS = 'ProjectDocuments';
export const ROUTE_PROJECT_EDIT = 'ProjectEdit';
export const ROUTE_PROJECT_CREATE = 'ProjectCreate';

export const ROUTE_PROJECT_DOCUMENT = 'ProjectDocument';
export const ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS = 'ProjectDocumentAssociations';

/** Use this one if you just need to link to The Project */
export const ROUTE_PROJECT_DEFAULT = ROUTE_PROJECT_CONTRACTS;

export const projectsRoutes: Array<RouteConfig> = [
  {
    path: '/projects',
    name: ROUTE_PROJECT,
    component: OtProjectsIndex,
    meta: {
      breadcrumb: 'projects',
      requiresAuth: true,
    },
  },
  {
    path: '/projects/create',
    name: ROUTE_PROJECT_CREATE,
    component: OtEditProjectDetails,
    meta: {
      requiresAuth: true,
      breadcrumb: 'Projects/Create',
    },
  },
  {
    path: '/projects/:projectGid',
    component: OtProjectsLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        // in https://redgum.atlassian.net/browse/OTMAN-497 we changed the order of the tabs
        // there is no longer a sensible default slash for a project (it used to be details)
        // so, redirect to contracts if they don't specify anything
        path: '/',
        redirect: 'contracts',
      },
      {
        path: 'details',
        name: ROUTE_PROJECT_DETAILS,
        component: OtProjectDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Details`,
        },
      },
      {
        path: 'users',
        name: ROUTE_PROJECT_USERS,
        component: OtProjectUsersIndex,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Users`,
        },
      },
      {
        path: 'contracts',
        name: ROUTE_PROJECT_CONTRACTS,
        component: OtProjectContractsIndex,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Contracts`,
        },
      },
      {
        path: 'workflows',
        name: ROUTE_PROJECT_WORKFLOWS,
        component: OtProjectClaimsIndex,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Workflows`,
        },
      },
      {
        path: 'documents',
        name: ROUTE_PROJECT_DOCUMENTS,
        component: OtProjectDocumentsIndex,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Documents`,
        },
      },
    ],
  },
  {
    path: '/projects/:projectGid/edit',
    name: ROUTE_PROJECT_EDIT,
    component: OtEditProjectDetails,
    meta: {
      requiresAuth: true,
      breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Edit`,
    },
  },
  {
    path: '/projects/:projectGid/users/:userGid/edit',
    name: ROUTE_PROJECT_USER_EDIT,
    component: OtEditProjectUserDetails,
    meta: {
      requiresAuth: true,
      breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Users/${BreadcrumbsId.UserId}/Edit`,
    },
  },
  {
    path: '/projects/:projectGid/users/:userGid',
    component: OtProjectUserLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_PROJECT_USER_DETAILS,
        component: OtProjectUserDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Users/${BreadcrumbsId.UserId}`,
        },
      },
      {
        path: 'contracts',
        name: ROUTE_PROJECT_USER_CONTRACTS,
        component: OtProjectUserContractsIndex,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Users/${BreadcrumbsId.UserId}/Contracts`,
        },
      },
    ],
  },
  {
    path: '/projects/:projectGid/documents/:documentGid',
    component: OtProjectDocumentLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_PROJECT_DOCUMENT,
        // Yes, this is not org specific, it's a shared document component
        component: OtDocumentDetails,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Documents/${BreadcrumbsId.DocumentId}`,
        },
      },
      {
        path: 'associations',
        name: ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS,
        // normal list import doesn't work for projects. Don't know why.
        //component: OtDocumentAssociationsList,
        // wrapper import does work, but I don't like it.
        //component: OtDocumentAssociationsListWrapper,
        // this weird import works. It's like the import that we have to do sometimes in the components declarations
        component: () => import('@/components/documents/document-associations/ot-document-associations-list.vue'), //OtDocumentAssociationsListWrapper,
        meta: {
          breadcrumb: `Projects/${BreadcrumbsId.ProjectId}/Documents/${BreadcrumbsId.DocumentId}/associations`,
        },
      },
    ],
  },
];
